import { css } from "styled-components";
import {
  getNewLookTokens,
  NEW_LOOK_RADIUS,
  newLookType, getPanelShadow } from "common/NewLook/tokens.ts";

/**
 * New look: a card on the canvas (bot cards, public bot cards). A panel
 * surface: white, a 1px hairline, radius 16 and the soft dashboard shadow.
 * The hairline is an inset shadow so the selected and focused states can
 * thicken it without shifting the content.
 */
export const newLookCardSurface = css`
  background: ${(p) => getNewLookTokens(p.theme).panel};
  border-radius: ${NEW_LOOK_RADIUS.panel}px;
  box-shadow: ${(p) => getPanelShadow(p.theme)};
  transition: box-shadow 150ms ease, transform 150ms ease;
`;

/** A clickable card: lifts a little on hover, the focus ring on keys. */
export const newLookCardInteractive = css`
  cursor: pointer;
  &:hover {
    transform: translateY(-1px);
    box-shadow: inset 0 0 0 1px
        ${(p) => getNewLookTokens(p.theme).hairlineStrong},
      0 4px 12px rgba(16, 24, 40, 0.08);
  }
  &:focus-visible {
    outline: none;
    box-shadow: inset 0 0 0 1px ${(p) => getNewLookTokens(p.theme).accent},
      0 0 0 3px ${(p) => getNewLookTokens(p.theme).focus};
  }
`;

/** A selected card (bulk selection): the hairline in brand blue. */
export const newLookCardSelected = css`
  &,
  &:hover {
    box-shadow: inset 0 0 0 1.5px ${(p) => getNewLookTokens(p.theme).accent},
      ${(p) => p.theme.shadows.dashboardCard};
  }
`;

/**
 * A small neutral settings chip ("Spot", "Isolated 3x", "500 USD"): radius 6,
 * a well with a hairline, meta text in the secondary grey.
 */
export const newLookChip = css`
  flex: none;
  display: inline-flex;
  align-items: center;
  height: 22px;
  padding: 0 8px;
  border-radius: ${NEW_LOOK_RADIUS.chip}px;
  background: ${(p) => getNewLookTokens(p.theme).well};
  box-shadow: inset 0 0 0 1px ${(p) => getNewLookTokens(p.theme).hairline};
  ${newLookType.meta};
  color: ${(p) => getNewLookTokens(p.theme).secondary};
  white-space: nowrap;
`;

/** An inset well inside a panel or card (the bot card's "now" panel). */
export const newLookWell = css`
  background: ${(p) => getNewLookTokens(p.theme).well};
  border-radius: ${NEW_LOOK_RADIUS.control}px;
  box-shadow: inset 0 0 0 1px ${(p) => getNewLookTokens(p.theme).hairline};
`;

/** New look: underline tabs inside a panel header (antd Tabs). */
export const newLookPanelTabs = css`
  &.ant-tabs > .ant-tabs-nav {
    margin: 0;
  }
  &.ant-tabs > .ant-tabs-nav .ant-tabs-nav-wrap {
    padding: 0 20px;
  }
  &.ant-tabs > .ant-tabs-nav::before {
    border-bottom: 1px solid ${(p) => getNewLookTokens(p.theme).hairline};
  }
  .ant-tabs-tab {
    min-height: 52px;
    padding: 0;
    ${newLookType.label};
    font-size: 13.5px;
  }
  .ant-tabs-tab + .ant-tabs-tab {
    margin: 0 0 0 20px;
  }
`;
